import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { SelectedBookingCourt, SelectedBookingDetail, SelectedBookingEditParams } from './types';

export interface CourtsBookingState {
  activeBookingIds: number[] | null;
  activeBookingCourt: SelectedBookingCourt | null;
  activeBookingDetail: SelectedBookingDetail | null;
  activeBookingEditParams: SelectedBookingEditParams | null;
}

const initialState: CourtsBookingState = {
  activeBookingIds: null,
  activeBookingCourt: null,
  activeBookingDetail: null,
  activeBookingEditParams: null
};

const courtsBookingSlice = createSlice({
  name: 'courtsBooking',
  initialState,
  reducers: {
    changeActiveBookingIds: (state, action: PayloadAction<number[] | null>) => {
      state.activeBookingIds = action.payload;
    },
    changeActiveBookingCourt: (state, action: PayloadAction<SelectedBookingCourt | null>) => {
      state.activeBookingCourt = action.payload;
    },
    changeActiveBookingDetail: (state, action: PayloadAction<SelectedBookingDetail | null>) => {
      state.activeBookingDetail = action.payload;
    },
    changeActiveBookingEditParams: (state, action: PayloadAction<SelectedBookingEditParams | null>) => {
      state.activeBookingEditParams = action.payload;
    }
  }
});

export const selectActiveBookingIds = (state: RootState) => state.courtsBooking.activeBookingIds;
export const selectActiveBookingCourt = (state: RootState) => state.courtsBooking.activeBookingCourt;
export const selectActiveBookingDetail = (state: RootState) => state.courtsBooking.activeBookingDetail;
export const selectActiveBookingEditParams = (state: RootState) => state.courtsBooking.activeBookingEditParams;

export const { changeActiveBookingCourt, changeActiveBookingIds, changeActiveBookingDetail, changeActiveBookingEditParams } = courtsBookingSlice.actions;
export { courtsBookingSlice };
